// EN: event name / ED: event description
const BUTTON_CLICKED_SUFFIX = 'button clicked';
const PAYWALL_SEEN_SUFFIX = 'paywall seen';
const TYPE = {
  FEATURE: 'feature',
  MARKETING: 'marketing',
  ADDITIONAL_QUANTITIES: 'additional_quantities',
  ONBOARDING: 'onboarding',
  SIGNUP: 'signup',
  TECHNICAL: 'technical',
};

const LOCATION = {
  UNKNOWN: 'unknown',
  TRANSACTIONS_HEADER: 'transactions_header',
  TRANSACTIONS_FOOTER: 'transactions_footer',
};

const TRIGGER = {
  UNKNOWN: 'unknown',
};

export default {
  BASE_VALUES: {
    bank_add_tentative: 40,
    bank_added: 110,
    free_trial: 230,
  },
  EN_PROACTIVE_SUBSCRIPTION_BUTTON_CLICKED: {
    name: `Proactive subscription ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'proactive_subscription_button'},
  },
  EN_FUNDING_BUTTON_CLICKED: {
    name: `Funding ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'funding_button', type: TYPE.MARKETING},
  },
  EN_SCENARIO_BUTTON_CLICKED: {
    name: `Scenario ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'scenario_button', type: TYPE.FEATURE},
  },
  EN_ONBOARDING_BUTTON_CLICKED: {
    name: `Onboarding ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'onboarding_button'},
  },
  EN_AVSE_UNLOCK_BUTTON_CLICKED: {
    name: `Unlock AvsE ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'avse_button', type: TYPE.FEATURE},
  },
  EN_EXCEL_UNLOCK_BUTTON_CLICKED: {
    name: `Unlock Excel export ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'excel_button', type: TYPE.FEATURE},
  },
  EN_ADD_USER_BUTTON_CLICKED: {
    name: `Add a user ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'add_user_button', type: TYPE.ADDITIONAL_QUANTITIES},
  },
  EN_ADD_BANK_BUTTON_CLICKED: {
    name: `Add a bank ${BUTTON_CLICKED_SUFFIX}`,
    properties: {
      id: 'add_bank_button',
      type: TYPE.ADDITIONAL_QUANTITIES,
      location: LOCATION.UNKNOWN,
    },
  },
  EN_VIEW_RULES_BUTTON_CLICKED: {
    name: `View my rules ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'view_rules_button', type: TYPE.FEATURE},
  },
  EN_VIEW_PERMISSION_GROUPS_BUTTON_CLICKED: {
    name: `View permission groups ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'view_permission_groups_button', type: TYPE.FEATURE},
  },
  EN_FILTER_TRANSACTIONS_BUTTON_CLICKED: {
    name: `Filter transactions ${BUTTON_CLICKED_SUFFIX}`,
    properties: {
      id: 'filter_transactions_button',
      type: TYPE.FEATURE,
      location: LOCATION.TRANSACTIONS_HEADER,
    },
  },

  // ── Transactions : barre de filtres (refonte TT-6903) ──────────────────
  // Un seul nom d'event par intention, dimensionné par des propriétés
  // runtime, plutôt que N noms pour N facettes : le schéma Segment reste
  // exploitable quand on ajoute une facette.
  //
  // Propriétés attendues à l'appel :
  //   filter_type          'status' | 'date' | 'receipt' | 'amount' |
  //                        'accounts' | 'cards' | 'category' |
  //                        'noCategories' | 'search' | 'all'
  //   source               'chip' | 'chip_bar' | 'add_menu'
  //   active_filters_count Number — nombre de critères actifs
  //
  // À émettre depuis un handler de clic, jamais depuis un watcher :
  // `setDisplayed()` et les actions d'archivage réécrivent le statut par
  // programme, ce qui produirait des events fantômes.
  EN_REFRESH_TRANSACTIONS_BUTTON_CLICKED: {
    name: `Refresh transactions ${BUTTON_CLICKED_SUFFIX}`,
    properties: {
      id: 'refresh_transactions_button',
      type: TYPE.FEATURE,
      location: LOCATION.TRANSACTIONS_HEADER,
    },
  },
  EN_TRANSACTIONS_FILTER_APPLIED: {
    name: 'Transactions filter applied',
    properties: {id: 'transactions_filter', type: TYPE.FEATURE},
  },
  EN_TRANSACTIONS_FILTER_CLEARED: {
    name: 'Transactions filter cleared',
    properties: {id: 'transactions_filter', type: TYPE.FEATURE},
  },
  EN_INVOICES_FILTER_APPLIED: {
    name: 'Invoices filter applied',
    properties: {id: 'invoices_filter', type: TYPE.FEATURE},
  },
  EN_INVOICES_FILTER_CLEARED: {
    name: 'Invoices filter cleared',
    properties: {id: 'invoices_filter', type: TYPE.FEATURE},
  },
  EN_UPGRADE_BUTTON_CLICKED: {
    name: `Upgrade ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'upgrade_button', trigger: TRIGGER.UNKNOWN},
  },
  EN_USER_REDIRECTED_TO_AIS_PROVIDER: {
    name: `User redirected to AIS provider ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'ais_redirection'},
  },
  EN_BANK_SEARCHED: {
    name: 'Bank searched',
    properties: {type: TYPE.ONBOARDING},
  },
  EN_BANK_NOT_FOUND: {
    name: 'Bank not found',
    properties: {type: TYPE.ONBOARDING},
  },
  EN_COMPANY_SEARCHED: {
    name: 'Company searched',
    properties: {type: TYPE.ONBOARDING},
  },
  EN_SIGNUP_CLICKED: {
    name: `Sign up ${BUTTON_CLICKED_SUFFIX}`,
    properties: {type: TYPE.SIGNUP},
  },
  EN_SIGNUP_PAGE_VIEWED: {
    name: 'Sign up page viewed',
    properties: {type: TYPE.SIGNUP},
  },
  EN_FREE_TRIAL_PAYWALL_SEEN: {
    name: `Free trial ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'free_trial_paywall'},
  },
  EN_CATEGORY_LEVEL_PAYWALL_SEEN: {
    name: `Category level ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'category_level_paywall'},
  },
  EN_AVSE_PAYWALL_SEEN: {
    name: `Avse ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'avse_paywall'},
  },
  EN_SCENARIO_NUMBER_PAYWALL_SEEN: {
    name: `Scenario number ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'scenario_number_paywall'},
  },
  EN_EXCEL_PAYWALL_SEEN: {
    name: `Excel ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'excel_paywall'},
  },
  EN_PERMISSION_GROUPS_PAYWALL_SEEN: {
    name: `Permission groups ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'permission_groups_paywall'},
  },
  EN_ADDITIONAL_BANK_PAYWALL_SEEN: {
    name: `Aadditional bank ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'additional_bank_paywall'},
  },
  EN_ANALYTICS_PAYWALLS_SEEN: {
    name: `Analytics ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'analytics_paywall'},
  },
  EN_ADDITIONAL_USER_PAYWALL_SEEN: {
    name: `Additional user ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'additional_user_paywall'},
  },
  EN_ADDITIONAL_INTEGRATION_PAYWALLS_SEEN: {
    name: `Additional integration ${PAYWALL_SEEN_SUFFIX}`,
    properties: {id: 'additional_integration_paywall'},
  },
  EN_ADD_PARTNER_INTEGRATION_BUTTON_CLICKED: {
    name: `Add a partner integration ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'add_partner_integration_button', type: TYPE.FEATURE},
  },
  EN_UPDATE_PARTNER_INTEGRATION_BUTTON_CLICKED: {
    name: `Update a partner integration ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'update_partner_integration_button', type: TYPE.FEATURE},
  },
  EN_PARTNER_CARD_BUTTON_CLICKED: {
    name: `Partner card ${BUTTON_CLICKED_SUFFIX}`,
    properties: {id: 'partner_card_button', type: TYPE.FEATURE},
  },
  EN_USER_SESSION_STARTED: {
    name: 'User started a new session of navigation',
    properties: {type: TYPE.TECHNICAL},
  },
  EN_TREASURY_INVESTMENT_BUTTON_CLICKED: {
    name: `Treasury investment ${BUTTON_CLICKED_SUFFIX}`,
    properties: {type: TYPE.FEATURE},
  },
  EN_TREASURY_SUBSCRIPTION_BUTTON_CLICKED: {
    name: `Treasury subscription ${BUTTON_CLICKED_SUFFIX}`,
    properties: {type: TYPE.FEATURE},
  },
  EN_TREASURY_WITHDRAWAL_BUTTON_CLICKED: {
    name: `Treasury withdrawal ${BUTTON_CLICKED_SUFFIX}`,
    properties: {type: TYPE.FEATURE},
  },
  EN_TREASURY_TRANSFER_ORDERED: {
    name: `Treasury transfer ordered`,
    properties: {type: TYPE.FEATURE},
  },
  EN_AI_FORECAST_BTN_CLICKED: {
    name: `AI forecasts button clicked`,
    properties: {type: TYPE.FEATURE},
  },
  EN_AI_FORECAST_CREATED: {
    name: `AI forecasts created`,
    properties: {type: TYPE.FEATURE},
  },
  EN_AI_FORECAST_INTERVAL_OPENED: {
    name: `AI forecasts interval opened`,
    properties: {type: TYPE.FEATURE},
  },
  EN_AI_FORECAST_INTERVAL_APPLIED: {
    name: `AI forecasts interval applied`,
    properties: {type: TYPE.FEATURE},
  },
  EN_AI_BATCH_OPENED: {
    name: `AI forecasts batch opened`,
    properties: {type: TYPE.FEATURE},
  },
  EN_AI_BATCH_ANALYSED: {
    name: `AI forecasts batch analysed`,
    properties: {type: TYPE.FEATURE},
  },
  EN_AI_BATCH_MODE_SELECTED: {
    name: `AI forecasts batch mode selected`,
    properties: {type: TYPE.FEATURE},
  },
  EN_AI_BATCH_LAUNCHED: {
    name: `AI forecasts batch launched`,
    properties: {type: TYPE.FEATURE},
  },
  EN_AI_BATCH_COMPLETED: {
    name: `AI forecasts batch completed`,
    properties: {type: TYPE.FEATURE},
  },
  EN_AI_BATCH_INTERRUPTED: {
    name: `AI forecasts batch interrupted`,
    properties: {type: TYPE.FEATURE},
  },
  EN_AI_BATCH_RESUMED: {
    name: `AI forecasts batch resumed`,
    properties: {type: TYPE.FEATURE},
  },
  EN_AI_BATCH_UNDONE: {
    name: `AI forecasts batch undone`,
    properties: {type: TYPE.FEATURE},
  },
  EN_LOCALSTORAGE_CLEAR: {
    name: `LOCALSTORAGE removed largest item`,
    properties: {type: TYPE.TECHNICAL},
  },
  EN_CUSTOM_REPORT_CREATED: {
    name: `Custom report button clicked`,
    properties: {type: TYPE.FEATURE},
  },
  EN_CUSTOM_INDICATOR_CREATE_FAIL: {
    name: `Creation of a custom indicator failed`,
    properties: {type: TYPE.FEATURE},
  },
  EN_INTERNAL_TRANSFER_ATTEMPT: {
    name: `Attempt to transfer funds between user accounts`,
    properties: {type: TYPE.FEATURE},
  },
  EN_MAINTENANCE_VIEW_SHOWN: {
    name: `User redirected to maintenance view`,
    properties: {type: TYPE.TECHNICAL},
  },
  EN_PRESENTATION_VIEWED: {
    name: `Presentation viewed`,
    properties: {id: 'presentation', type: TYPE.MARKETING},
  },
  EN_PRESENTATION_WATCH_ENDED: {
    name: `Presentation watch ended`,
    properties: {id: 'presentation', type: TYPE.MARKETING},
  },
  // Onboarding tour funnel (V1) — emitted centrally from the tour engine
  // (src/lib/tourEngine.js). Shared props added at emit time: tour_id,
  // company_id, is_impersonated, schema_version, source, step_count.
  EN_TOUR_STARTED: {
    name: 'Tour started',
    properties: {type: TYPE.ONBOARDING},
  },
  EN_TOUR_STEP_VIEWED: {
    name: 'Tour step viewed',
    properties: {type: TYPE.ONBOARDING},
  },
  EN_TOUR_COMPLETED: {
    name: 'Tour completed',
    properties: {type: TYPE.ONBOARDING},
  },
  EN_TOUR_EXITED: {
    name: 'Tour exited',
    properties: {type: TYPE.ONBOARDING},
  },
  // Onboarding journey progress (V2) — fired once when the full "Prise en main"
  // socle is complete (src/store/onboarding.js).
  EN_ONBOARDING_JOURNEY_COMPLETED: {
    name: 'Onboarding journey completed',
    properties: {type: TYPE.ONBOARDING},
  },
};
